export default __webpack_public_path__ + "static/woman-3a71494c2e76d78226aeb79ad88ede7a.png";